import React from 'react';
import HPCustomerSupport from './HPCustomerSupport';

const View = () => <HPCustomerSupport />;

export default View;